module.exports = __webpack_public_path__ + "files/eacff598cf65cf9c01c7c96d2a368a9b.svg";